import React, { Suspense } from "react";
import DashboardCard from "@/features/dashboard/components/dashboard-card";
import MarkupTrendHeader from "@/features/dashboard/features/markup-trend-section/components/markup-trend-header";
import { MemoizedMarkupTrendChart } from "@/features/dashboard/features/markup-trend-section/components/markup-trend-chart";
import DashboardCardSpinner from "@/features/dashboard/components/dashboard-card-spinner";

export default function MarkupTrendSection() {
  return (
    <DashboardCard>
      <DashboardCard.Header>
        <MarkupTrendHeader />
      </DashboardCard.Header>
      <DashboardCard.Body>
        <Suspense fallback={<DashboardCardSpinner />}>
          <MemoizedMarkupTrendChart />
        </Suspense>
      </DashboardCard.Body>
    </DashboardCard>
  );
}
